<script>
import default_img from "@img/defaults/product-not-found.webp";

export default {
    name: "ProductImageLoad",
    props: {
        img_key: {},
        img: {
            required: true,
        },
    },
    data() {
        return {
            imageLoaded: false,
        }
    },
    methods: {
        onImageLoad() {
            this.imageLoaded = true;
        },
        replaceByDefaultImg(event) {
            event.target.src = '/assets/defaults/product-not-found.webp';
        },
    },
    setup() {
        return {default_img}
    }
}
</script>

<template>
    <img :key="img_key"
         @load="onImageLoad"
         @error="replaceByDefaultImg"
         :src="img ? img : default_img"
         :title="'Продукт ' + img_key" :alt="'Продукт ' + img_key"
         class="absolute block w-full h-full object-cover -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2 group-hover:scale-110 transform transition-transform duration-300"/>
</template>

<style scoped lang="scss">

</style>
